import { render, staticRenderFns } from "./invitationDia.vue?vue&type=template&id=4b84dd26&scoped=true&"
import script from "./invitationDia.vue?vue&type=script&lang=js&"
export * from "./invitationDia.vue?vue&type=script&lang=js&"
import style0 from "./invitationDia.vue?vue&type=style&index=0&id=4b84dd26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84dd26",
  null
  
)

export default component.exports